import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { PlanService } from 'services';
import { ViewIcon, EditIcon } from 'assets/icons';
import { Tooltip, Modal } from 'components';
import ModalUpdate from './modal-update';
import ModalView from './modal-view';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Plans extends React.Component<Props> {

	state = {
		plans: [],
		visible: false,
		visible_view: false,
		item: null,
		plan_modules: {}
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Planes de suscripción',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await PlanService.admin.get({
			withoutLoading
		});
		this.setState({
			plans: res.plans || [],
			plan_modules: res.plan_modules || {}
		});
	}

	edit = (e: any, item: any) => {
		if (e) {
			e.preventDefault();
		}
		this.setState({
			visible: true,
			visible_view: false,
			item
		});
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_view: true,
			item
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => {
			this.load(true);
		});
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		});
	}

	render() {
		const { plans, visible, visible_view } = this.state;

		return (
			<div id="admin-plans">
				<Modal
		          className="modal-update-plan"
		          visible={ visible }
		          title="Editar plan"
		          onClose={ () => this.onClose() }
		        >
		          <ModalUpdate
		            item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-view-plan"
		          visible={ visible_view }
		          title="Ver"
		          onClose={ () => this.onCloseView() }
		        >
		          <ModalView
		          	onUpdate={ (e: any) => {
		          		this.edit(e,this.state.item);
		          	} }
		          	modules={ this.state.plan_modules }
		            item={ this.state.item }
		            onClose={ () => this.onCloseView() } />
		      	</Modal>

				<div className="container-table">
					<h3>Planes</h3>
					{
						plans.map((item: any) => {
							return (
								<div className="item">
									{
										item?.image && (
											<img className="image" src={ Constants.BASE_STORAGE + item?.image } />
										)
									}
									<div style={{ flex: 1 }}>
										<p className="name">{ item?.name }</p>
										{
											item?.year_price > 0 && (
												<p className="price"><span>{ Globals.formatMiles(item?.year_price) }</span> Anual</p>
											)
										}
									</div>
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,item) }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
									{
										checkPermission(Constants.MODULES.USERS,'delete') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,item) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
								</div>
							)
						})
					}
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Plans);